import React from 'react'
import {
    Box,
    Skeleton,
    Stack,
    Card,
    CardContent,
} from "@mui/material";

const CartItemBoxes = () => {
    return [...Array(3)].map((_, i) => (
        <Card key={i} sx={{ mb: 2, borderRadius: 2, boxShadow: 1 }}>
            <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Skeleton variant="rectangular" width={80} height={80} />
                    <Box sx={{ flex: 1 }}>
                        <Skeleton width="60%" height={24} />
                        <Skeleton width="40%" height={24} />
                    </Box>
                    <Skeleton width={60} height={24} />
                </Stack>
            </CardContent>
        </Card>
    ))
}

export default CartItemBoxes